import request from '@/utils/request';

// 新增二维码-支持批量
export function batchAddQrCode(values) {
  return request('/wechat/mp/addQrcode', {
    method: 'POST',
    data: values,
  }).catch;
}

// 新增二维码组
export function addQrcodeGroup(values) {
  return request('/wechat/mp/addQrcodeGroup', {
    method: 'POST',
    data: values,
  });
}

// 删除二维码分组
export function deleteQrcodeGroup(values) {
  return request('/wechat/mp/deleteQrcodeGroup', {
    method: 'POST',
    data: values,
  });
}

// 分页查询 二维码分组详情-列表
export function queryQrcodeGroupPage(values) {
  return request('/wechat/mp/queryQrcodeGroupPage', {
    method: 'POST',
    data: values,
  });
}

// 编辑二维码名
export function updateQrcodeGroup(values) {
  return request('/wechat/mp/updateQrcodeGroup', {
    method: 'POST',
    data: values,
  });
}

// 二维码组-二维码下载
export function qrcodeGroupDownload(values) {
  return request('/wechat/mp/qrcodeGroupDownload', {
    method: 'POST',
    data: values,
  });
}
